import type {PullRequestActiveRoute} from '../hooks/use-active-route'

export interface PullRequestRouteConfig {
  /** Whether the layout should use full-width (files/changes/checks) or condensed (conversation/overview/commits). */
  layout: 'full-width' | 'condensed'
  /** Whether the docked side panel is supported on this route. */
  dockedPanelSupported: boolean
}

function buildRouteConfigs(overviewEnabled: boolean): Record<PullRequestActiveRoute, PullRequestRouteConfig> {
  return {
    overview: {
      layout: overviewEnabled ? 'full-width' : 'condensed',
      dockedPanelSupported: overviewEnabled,
    },
    conversation: {
      layout: overviewEnabled ? 'full-width' : 'condensed',
      dockedPanelSupported: overviewEnabled,
    },
    files_changed: {
      layout: 'full-width',
      dockedPanelSupported: true,
    },
    commits: {
      layout: overviewEnabled ? 'full-width' : 'condensed',
      dockedPanelSupported: overviewEnabled,
    },
    checks: {
      layout: 'full-width',
      dockedPanelSupported: overviewEnabled,
    },
    findings: {
      layout: overviewEnabled ? 'full-width' : 'condensed',
      dockedPanelSupported: false,
    },
    walkthrough: {
      layout: 'full-width',
      dockedPanelSupported: false,
    },
  }
}

export function getRouteConfig(activeRoute: PullRequestActiveRoute, overviewEnabled = false): PullRequestRouteConfig {
  return buildRouteConfigs(overviewEnabled)[activeRoute]
}
